import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { initSentry } from './sentry'
import { initAuthSessionSync } from './api/authSessionSync'
import './i18n/config'
import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/inter/800.css'
import '@fontsource/inter/900.css'
import '@fortawesome/fontawesome-free/css/all.min.css'

initSentry()
initAuthSessionSync()

ReactDOM.createRoot(document.getElementById('root')!).render(<App />)
